if (process.env.NODE_ENV === 'production') {
  module.exports = require('./typeface.production.js');
} else {
  module.exports = require('./typeface.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/typeface/dist/es/typeface.js
// module id = 85
// module chunks = 0